export default "__VITE_ASSET__BJGyW_He__"